import { render, staticRenderFns } from "./TencentyunCosUploadImg.vue?vue&type=template&id=5474445c&scoped=true&"
import script from "./TencentyunCosUploadImg.vue?vue&type=script&lang=js&"
export * from "./TencentyunCosUploadImg.vue?vue&type=script&lang=js&"
import style0 from "./TencentyunCosUploadImg.vue?vue&type=style&index=0&id=5474445c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5474445c",
  null
  
)

export default component.exports